<ion-card mode="ios" *ngFor="let questionGroup of _user?.threeSixtyEvaluationCalibrationData">
    <ion-card-content class="ion-no-padding">
        <app-calibration-qualitative-evaluation [questions]="questionGroup?.questions"
                                                [possibleValues]="_user?.ratings?.ratingsPossibleValues"></app-calibration-qualitative-evaluation>
    </ion-card-content>
</ion-card>
<p *ngIf="!_user?.threeSixtyEvaluationCalibrationData || _user?.threeSixtyEvaluationCalibrationData.length == 0">{{ 'externalEvaluation.notFound' | translate}}</p>